import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { CompleteRequestAction, DataSavedAction } from './actions';
import { EMPTY } from 'rxjs';
import { LeadService } from 'src/app/services/lead.service';

@Injectable()
export class NmjReviewEffects {
    constructor(private store: Store<any>,
        private actions$: Actions,
        private leadService: LeadService) {
    }

    complete$ = createEffect(() => this.actions$.pipe(
        ofType(CompleteRequestAction),
        switchMap((action: any) => this.leadService.complete(action.data).pipe(
            map((data: any) => {
                this.leadService.showOk(data.message);
                return DataSavedAction();
            }),
            catchError(_err => {
                return EMPTY;
            })
        )),
    ));
}
